import script from "./CardsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsView.vue?vue&type=script&setup=true&lang=js"

import "./CardsView.vue?vue&type=style&index=0&id=76bb2a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bb2a8a"]])

export default __exports__